import React from "react";
import * as Styled from "./Logo.styles";
import LogoImage from "../../../assets/logo-vodovod-rijeka.png";

export default function Logo() {
  return (
    <Styled.Logo background-color={"#ffffff"}>
      <img src={LogoImage} alt="moj vik" />
    </Styled.Logo>
  );
}
